// extracted by mini-css-extract-plugin
export default {"container":"LpSwipeQuestionChartForQuiz_container__qE5xI"};